// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallUnansweredTest24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g id="Icon/Communication/Call_&#8;Unanswered_test_24">
					<path
						id="Union"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M17.9219 10.4749L12.5305 15.8663C12.3834 16.0133 12.1905 16.0865 11.9978 16.0859C11.8066 16.0854 11.6155 16.0122 11.4696 15.8663L4.79787 9.19452C4.50497 8.90163 4.50497 8.42676 4.79787 8.13386C5.09076 7.84097 5.56564 7.84097 5.85853 8.13386L12 14.2754L16.8601 9.41531L13.954 9.41531C13.5398 9.41531 13.204 9.07953 13.204 8.66531C13.204 8.2511 13.5398 7.91531 13.954 7.91531L18.6308 7.91531C18.8362 7.9041 19.0453 7.97695 19.2022 8.13386C19.3488 8.28045 19.422 8.47263 19.4219 8.66476C19.4219 8.66494 19.4219 8.66513 19.4219 8.66531L19.4219 13.3832C19.4219 13.7974 19.0861 14.1332 18.6719 14.1332C18.2577 14.1332 17.9219 13.7974 17.9219 13.3832L17.9219 10.4749Z"
					/>
				</g>
			</Svg>
		);
	}
);
SvgCallUnansweredTest24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallUnansweredTest24;
